import React from 'react'

const Frontend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">DevOps</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data" data-aos="zoom-in" data-aos-delay="100">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">AWS</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data" data-aos="zoom-in" data-aos-delay="200">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Digital Ocean</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data" data-aos="zoom-in" data-aos-delay="300">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Hostinger</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frontend